import React from 'react';

function ArrowRouteIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="41" height="16" fill="none" viewBox="0 0 41 16">
      <path
        fill="#757575"
        fillRule="evenodd"
        d="M33.4.798l6.788 6.482a.986.986 0 010 1.44l-6.789 6.482a1.103 1.103 0 01-1.508 0 .986.986 0 010-1.44l4.967-4.744H.5V6.982h36.358l-4.967-4.743a.986.986 0 010-1.44 1.103 1.103 0 011.508 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ArrowRouteIcon;
